/* eslint-disable no-underscore-dangle */
import Enrollments from '@/services/Enrollments';
import { insertScript } from './document';

export const loadScriptsIfInTrial = async () => {
  if (!(await Enrollments.isInTrial())) return;

  const _window: any = window;
  _window.hj = {};
  _window._hjSettings = { hjid: 2890442, hjsv: 6 };

  insertScript(
    `https://static.hotjar.com/c/hotjar-${_window._hjSettings.hjid}.js?sv=${_window._hjSettings.hjsv}`,
  );
};
